import "./App.css";
import FontAwesome from 'react-fontawesome'
import faStyles from 'font-awesome/css/font-awesome.css'
import UncontrolledExample from "./components/CardComponent";

const App=()=> {
  return (
    <>
  <nav className="navbar navbar-expand-lg">
    <div className="container-fluid">
      <img className="navbar-brand" src="image/logo copy.jpg" alt="logo" />
      <ul className="navbar-nav d-flex flex-row me-1">
        <li className="nav-item me-3 me-lg-0">
          <a className="nav-link text-white" href="#">
            <i className="fa fa-envelope mx-1" /> Contact
          </a>
        </li>
        <li className="nav-item me-3 me-lg-0">
          <a className="nav-link text-white" href="#">
            <i className="fa fa-cog mx-1" /> Settings
          </a>
        </li>
        <li className="nav-item ">
          <a className="nav-link text-white" href="#">
            <i className="fa fa-user mx-1" /> Profile{" "}
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link text-white" href="#">
            <i className="fa fa-bell mx-1" /> Notification
          </a>
        </li>
      </ul>
    </div>
  </nav>

  <div className="container mb-5">
    <div className="row">
      <div className="col-lg-8 col-12 mt-5 mx-auto">
        <h1 className=" text-center">Discover. Learn. Enjoy</h1>
        <h6 className="text-center">platform for creatives around the world</h6>
        <div className="row height  justify-content-center">
          <div className="col-md-10">
            <div className="search">
              <i className="fa fa-search" />
              <input
                type="text"
                className="form-control"
                placeholder="Have a question? Ask Now"
              />
              <button className="btn btn-primary">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <UncontrolledExample/>
      </div>
    </div>
  </div>

  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <section className="wrapper">
          <div className="container">
            <div className="row">
              <div className="col text-center mb-5">
                <h1 className="display-4 font-weight-bolder">Video Tutorial</h1>
                <p className="lead">
                  Lorem ipsum dolor sit amet at enim hac integer volutpat
                  maecenas pulvinar.{" "}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta">Video-1 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Tube Base Fire Suppression system
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/1 & 2.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>Tube Base Fire Suppression system</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-2 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Fire Suppression System
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/1 & 2.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>Fire Suppression system</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-3 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Low Expansion foam Fire Protection system
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/3.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>
                            Low Expansion foam Fire Protection system
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-4 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Autometic Fire Sprinkler System
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/4.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>Autometic Fire Sprinkler System</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-5 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Fire Hydrant system
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/5.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>Fire Hydrant system</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-6 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Fire Pump Room
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/6.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>Fire Pump Room</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-7 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Firefighting Drone
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/7.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>Firefighting Drone</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-8 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Introduction and Classification of fire and how to use
                          fire extinguisher
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/8.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>
                            Introduction and Classification of fire and how to
                            use fire extinguisher
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
                <div className="card  card-has-bg">
                  <div className="card-img-overlay d-flex flex-column">
                    <div className="card-body">
                      <small className="card-meta mb-2">Video-9 </small>
                      <h4 className="card-title">
                        <a className="text-lite" herf="">
                          Emergency evacuation Procedure
                        </a>
                      </h4>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="video/9.mp4"
                        title="video"
                        allowFullScreen=""
                      />
                    </div>
                    <div className="card-footer">
                      <div className="media">
                        <div className="media-body">
                          <small>Emergency evacuation Procedure</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row">
      <div id="associate">
        <h1>OUR ASSOCIATE</h1>
        <section className="light">
          <div className="container py-2">
            <article className="postcard light blue">
              <a className="postcard__img_link" href="#">
                <img
                  className="postcard__img"
                  src="https://picsum.photos/1000/1000"
                  alt="Image Title"
                />
              </a>
              <div className="postcard__text t-dark">
                <h1 className="postcard__title blue">
                  <a href="#">Podcast Title</a>
                </h1>
                <div className="postcard__subtitle small">
                  <time dateTime="2020-05-25 12:00:00">
                    <i className="fa fa-calendar-check-o mr-2" />
                    Mon, May 25th 2020
                  </time>
                </div>
                <div className="postcard__bar" />
                <div className="postcard__preview-txt">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Eligendi, fugiat asperiores inventore beatae accusamus odit
                  minima enim, commodi quia, doloribus eius! Ducimus nemo
                  accusantium maiores velit corrupti tempora reiciendis
                  molestiae repellat vero. Eveniet ipsam adipisci illo iusto
                  quibusdam, sunt neque nulla unde ipsum dolores nobis enim
                  quidem excepturi, illum quos!
                </div>
              </div>
            </article>
            <article className="postcard light red">
              <a className="postcard__img_link" href="#">
                <img
                  className="postcard__img"
                  src="https://picsum.photos/501/500"
                  alt="Image Title"
                />
              </a>
              <div className="postcard__text t-dark">
                <h1 className="postcard__title red">
                  <a href="#">Podcast Title</a>
                </h1>
                <div className="postcard__subtitle small">
                  <time dateTime="2020-05-25 12:00:00">
                    <i className="fa fa-calendar-check-o mr-2" />
                    Mon, May 25th 2020
                  </time>
                </div>
                <div className="postcard__bar" />
                <div className="postcard__preview-txt">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Eligendi, fugiat asperiores inventore beatae accusamus odit
                  minima enim, commodi quia, doloribus eius! Ducimus nemo
                  accusantium maiores velit corrupti tempora reiciendis
                  molestiae repellat vero. Eveniet ipsam adipisci illo iusto
                  quibusdam, sunt neque nulla unde ipsum dolores nobis enim
                  quidem excepturi, illum quos!
                </div>
              </div>
            </article>
            <article className="postcard light green">
              <a className="postcard__img_link" href="#">
                <img
                  className="postcard__img"
                  src="https://picsum.photos/500/501"
                  alt="Image Title"
                />
              </a>
              <div className="postcard__text t-dark">
                <h1 className="postcard__title green">
                  <a href="#">Podcast Title</a>
                </h1>
                <div className="postcard__subtitle small">
                  <time dateTime="2020-05-25 12:00:00">
                    <i className="fa fa-calendar-check-o mr-2" />
                    Mon, May 25th 2020
                  </time>
                </div>
                <div className="postcard__bar" />
                <div className="postcard__preview-txt">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Eligendi, fugiat asperiores inventore beatae accusamus odit
                  minima enim, commodi quia, doloribus eius! Ducimus nemo
                  accusantium maiores velit corrupti tempora reiciendis
                  molestiae repellat vero. Eveniet ipsam adipisci illo iusto
                  quibusdam, sunt neque nulla unde ipsum dolores nobis enim
                  quidem excepturi, illum quos!
                </div>
              </div>
            </article>
            <article className="postcard light yellow">
              <a className="postcard__img_link" href="#">
                <img
                  className="postcard__img"
                  src="https://picsum.photos/501/501"
                  alt="Image Title"
                />
              </a>
              <div className="postcard__text t-dark">
                <h1 className="postcard__title yellow">
                  <a href="#">Podcast Title</a>
                </h1>
                <div className="postcard__subtitle small">
                  <time dateTime="2020-05-25 12:00:00">
                    <i className="fa fa-calendar-check-o mr-2" />
                    Mon, May 25th 2020
                  </time>
                </div>
                <div className="postcard__bar" />
                <div className="postcard__preview-txt">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Eligendi, fugiat asperiores inventore beatae accusamus odit
                  minima enim, commodi quia, doloribus eius! Ducimus nemo
                  accusantium maiores velit corrupti tempora reiciendis
                  molestiae repellat vero. Eveniet ipsam adipisci illo iusto
                  quibusdam, sunt neque nulla unde ipsum dolores nobis enim
                  quidem excepturi, illum quos!
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </div>
  </div>
  <footer>
    <div className="container">
      <div className="col-lg-12 footer">
        <address>
          <div className="text-center">
            <img src="image/logo copy.jpg" className="rounded" alt="logo" />
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <span className="fa  fa-map-marker" /> &nbsp; &nbsp; &nbsp;
            <span className="visit">
              NFSSC Campus No. 1-Plot No. 104,105,1,Ajani Road, New Behind
              Dragon Palace Temple Kamptee Nagpur-441002(MH)
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center mb-2">
            <span className="fa fa-phone checked" /> &nbsp; &nbsp; &nbsp;
            <span className="visit">
              {" "}
              PHONE NO: +91-9422328101, +91-9827723101
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <span className="fa fa-envelope checked" /> &nbsp; &nbsp;
            <span className="visit"> office.scross@gmail.com </span>
          </div>
        </address>
        <div className="mt-5">
          <ul className="icon flex">
            <li>
              <a href="#">
                <i className="fa fa-facebook" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-twitter" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-instagram" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-linkedin" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa  fa-edge" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</>
  )
}

export default App;
